import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { Invitation } from 'src/features/userManagement/types';

const RESOURCE = '/parkings/:parkingId/invitations/:invitationId/resend/';

interface DTO extends Invitation {
    parkingId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ id, parkingId }: DTO): Promise<void> => {
    return axios.post(formatResourcePath(RESOURCE, { invitationId: id, parkingId }));
};

interface UseMutationOptions extends MutationConfig<MutationFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as RESEND_INVITATION_RESOURCE, useMutationHook as useResendInvitation };
export type { DTO as ResendInvitationDTO };
